import React from 'react';
import Permissions from '../../pages/Permissions';

export default function PermissionsViewContainer({ records, providers, permissions, onRevokePermission, onGrantPermission }) {
  return (
    <Permissions
      records={records}
      providers={providers}
      permissions={permissions}
      onRevokePermission={onRevokePermission}
      onGrantPermission={onGrantPermission}
    />
  );
}
